export interface ButtonProps {
  title?: string;
  onClick: any;
  children?: any;
}

export const Button = (props: ButtonProps) => {
  return <button {...props} />;
};
